import { render, staticRenderFns } from "./MwDatePicker.vue?vue&type=template&id=54c83169&"
import script from "./MwDatePicker.vue?vue&type=script&lang=js&"
export * from "./MwDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports